import $ from 'jquery';
import _ from 'lodash-es';
import sections from '@shopify/theme-sections';
import openModal from '../../components/INF-Modal/openModal';
import populateCarousels from '../../sections/INF-ProductOverview/populateCarousels';
import { initProductCarousels } from '../../sections/INF-ProductOverview/carousel';

export default (product_url) => {
  let ajax_url;
  
  if (product_url.indexOf('?') >= 0) {
    ajax_url = `${product_url}&view=ajax`;
  } else {
    ajax_url = `${product_url}?view=ajax`;
  }

  const $modal = $('#QuickView');
  const $quick_view_content = $('[data-quick-view-content]');

  $modal.addClass('QuickView--loading');
  
  // Only empty the modal immediately if it's not already open. This starts you immediately with a clean loader.
  // If the modal IS already open, it means we're loading another PDP into the existing modal and want a smooth fade out animation of the existing content.
  if (!$modal.hasClass('Modal--open')) {
    $quick_view_content.empty();
  }

  openModal($modal);

  $.get(ajax_url, (response) => {
    const $product = $('<div />').html(response).find('[data-quick-view-container]');
    const $product_json = $('<div />').html(response).find('[data-product-json]');

    // Remove any special animation classes and replace them with a simple fade in
    $product.find('.Animate, .AnimateOnLoad').attr('class', (i, class_name) => {
      return class_name.replace(/(^|\s)Animate--\S+/g, '');
    });
    $product.find('.Animate, .AnimateOnLoad').addClass('Animate--fade-in');

    $quick_view_content.empty().append($product).append($product_json);
    $quick_view_content.find('select').not('[data-no-selectric], [data-no-selectric] select').selectric();

    sections.getInstances('product')
      .then((instances) => {
        return _.each(instances, (instance) => {
          instance.trigger('section_load');
        });
      })
      .catch((err) => {
        console.log(err);
      });
    
    populateCarousels();
    initProductCarousels('QuickView');

    // Slightly hacky, but make sure the right image is shown on page
    if ($('[data-custom-variant-selector]', $quick_view_content).is('select')) {
      $('[data-custom-variant-selector]', $quick_view_content).selectric('refresh').trigger('change');
    } else {
      $('.ProductOption__variant--selected', $quick_view_content).trigger('click');
    }
    
    // While not strictly necessary, this 100ms delay helps smooth out the animations
    // setTimeout(() => {
    $modal.removeClass('QuickView--loading');      
    // This just readjusts sizes, runs animations, etc.
    openModal($modal);
    // }, 100);
  });
};